import {
  I18N_SUBMIT_CONFIRMATION_BUTTON_KEY,
  I18N_SUBMIT_DISCLAIMER_KEY,
  I18N_WARNINGS_CHECK_LABEL_KEY
} from 'lf-at-theme';

/**
 * App i18n object for the en-US locale.
 */

export const appI18NEnUS: Record<string, any> = {
  '*': {
    saveFileName: 'oss-union-registration',
    [I18N_SUBMIT_DISCLAIMER_KEY]: 'You are about to submit a Union Scheme registration. Making it so you are agreeing with the fact that your not registered in the Union Scheme in other Member State.',
    [I18N_SUBMIT_CONFIRMATION_BUTTON_KEY]: 'Submit',
    [I18N_WARNINGS_CHECK_LABEL_KEY]: 'I declare that I am aware of the warnings generated by the data of this declaration.',
    ["modalYesBtn"]: 'Confirm',
    ["modalNoBtn"]: 'Cancel',
    ["schemeConditionsTitle"]: 'Admission Conditions',
    ["schemeConditions"]: `
      <p>To register in this scheme you should meet <strong>one</strong> of these conditions:</p>
      <ul>
        <li>You are a <strong>taxable person established in the EU</strong> and want to declare and pay VAT for supplies of B2C services taking place in other Member, or intra-Community distance sales of goods;</li>
        <li>You are a <strong>taxable person not established in the EU</strong> and want to declare and pay VAT for intra-Community distance sales of goods;</li>
        <li>You are an <strong>electronic interface</strong> (established in the EU or outside the EU) facilitating supplies of goods for intra-Community distance sales of goods and certain domestic supplies of goods;</li>
      </ul>
    `
  }
};
